import React from 'react'
import ColorExplorer from '../tool/ColorExplorer'

export default function WebColors(props) {
  return (
    <ColorExplorer />
  )
}
